import React from 'react';
import { Link, browserHistory, withRouter } from 'react-router';
import { header } from 'constants/table';
import { RowItemDanhSachDon } from './datatable';
import DataTable from 'components/data-table';
import { Button } from "@blueprintjs/core";
import { TheoDoiGiamSat } from 'api';
import { ShowIf } from 'components/utils';
import queryString from 'query-string';
import moment from 'moment';
import { API_URL } from 'constants/config';
import {downloadFile} from "constants/downloadFile";
import { get } from 'lodash';

class DanhSachDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    const parsed = queryString.parse(window.location.search);
    this.state = {
      data: [],
      tinhTrangXuLy: parsed.tinhTrangXuLy || '',
      trangThaiDon: parsed.trangThaiDon || '',
      state: this.props.state || '',
      id: this.props.id || '',
      donChuaChuyen: parsed.isPhongBanChuaChuyenDon || '',
      tuKhoa: '',
      tieuDe: '',
      tiepNhanTuNgay: localStorage.getItem('tdgs.tiepNhanTuNgay') ? new Date(localStorage.getItem('tdgs.tiepNhanTuNgay')) : '',
      tiepNhanDenNgay: localStorage.getItem('tdgs.tiepNhanDenNgay') ? new Date(localStorage.getItem('tdgs.tiepNhanDenNgay')) : '',
      year: localStorage.getItem('tdgs.year') || '',
      month: localStorage.getItem('tdgs.month') || '',
      phanHe: localStorage.getItem('tdgs.phanHe') || 'XU_LY_DON',
      loaiDonThu: localStorage.getItem('tdgs.loaiDonThu') || '',
      timKiemTheo: localStorage.getItem('tdgs.timKiemTheo') || 'day',
      nguonDon: localStorage.getItem('tdgs.nguonDon') || '',
      tableLoading: false,
      searchLoading: false,
      search: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tenDonVi: ''
    }
  }

  componentDidMount() {
    this.getListData();
    this.getTenDonVi();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  getTenDonVi() {
    let params = {
      donViId: this.props.id,
      tinhTrangXuLy: this.state.tinhTrangXuLy,
      isPhongBanChuaChuyenDon: this.state.donChuaChuyen === "true" ? true : undefined
    }
    TheoDoiGiamSat.actions.getTenDonViTaiDanhSachDungHanTreHan.request('',params).then(res => {
      if(res.data) {
        this.setState({
          tieuDe: res.data.tieuDe,
          tenDonVi: get(res, 'data.donVi.ten', '')
        });
      }
    })
  }

  getListData() {
    let params = this.createParams();

    this.setState({
      tableLoading: true,
      searchLoading: true
    });

    TheoDoiGiamSat.actions.getDanhSachDonDungHanTreHanTaiDonVi.request('',params).then(res => {
      if(res.data._embedded) {
        this.setState({
          data: res.data._embedded.dons,
          pageData: res.data.page
        });
      } else {
        this.setState({
          data: [],
          pageData: res.data.page
        });
      }
      this.setState({
        tableLoading: false,
        searchLoading: false
      });
    })
  }

  onChange(e) {
    this.setState({
      tuKhoa: e.target.value
    })
  }

  createParams() {
    let params = {
      quyTrinh: this.state.phanHe,
      phanLoaiDon: this.state.loaiDonThu,
      donViId: this.props.id,
      tinhTrangXuLy: this.state.tinhTrangXuLy,
      isPhongBanChuaChuyenDon: this.state.donChuaChuyen === "true" ? true : undefined,
      trangThaiDon: this.state.trangThaiDon,
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      nguonDon: this.state.nguonDon || undefined
    }

    if (this.state.search) {
      params.tuKhoa = this.state.tuKhoa;
    }

    if (this.state.tiepNhanTuNgay) {
      params.tuNgay = moment(this.state.tiepNhanTuNgay).add(7,'hours').toISOString();
    }

    if (this.state.tiepNhanDenNgay) {
      params.denNgay = moment(this.state.tiepNhanDenNgay).add(7,'hours').toISOString();
    }

    if (this.state.month) {
      params.month = this.state.month;
    }

    if (this.state.year) {
      params.year = this.state.year;
    }

    return params;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  handleSearch() {
    this.setState({
      search: true
    }, () => {
      this.getListData();
    });
  }

  handleExportExcel() {
    let URL = String(API_URL) + "/theoDoiGiamSats/danhSachDonDungHanTreHanTaiDonVi/xuatExcel?"
    + "month=" + this.state.month
    + "&year=" + this.state.year
    + "&donViId=" + this.state.id
    + "&quyTrinh=" + this.state.phanHe
    + "&phanLoaiDon=" + this.state.loaiDonThu
    + "&trangThaiDon=" + this.state.trangThaiDon
    + "&tinhTrangXuLy=" + this.state.tinhTrangXuLy
    if (this.state.nguonDon) {
      URL = URL + "&nguonDon=" + this.state.nguonDon
    }
    if (this.state.donChuaChuyen) {
      URL = URL + "&isPhongBanChuaChuyenDon=" + this.state.donChuaChuyen
    }
    if (this.state.tiepNhanTuNgay) {
      URL = URL + "&tuNgay=" + moment(this.state.tiepNhanTuNgay).add(7,'hours').toISOString()
    }
    if (this.state.tiepNhanDenNgay) {
      URL = URL + "&denNgay=" + moment(this.state.tiepNhanDenNgay).add(7,'hours').toISOString()
    }
    downloadFile(URL);
  }

  render() {
    return (
      <div className="center reception-container">
        <div className="back-foward mb0">
          <Link onClick={ browserHistory.goBack } title="">Về trang trước</Link>
        </div>
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-theo-doi"></i>
              {this.state.tieuDe}
              <ShowIf condition={this.state.tiepNhanTuNgay != ''}>
                <span> từ ngày {moment(this.state.tiepNhanTuNgay).format('DD/MM/YYYY')}</span>
              </ShowIf>
              <ShowIf condition={this.state.tiepNhanDenNgay != ''}>
                <span> đến ngày {moment(this.state.tiepNhanDenNgay).format('DD/MM/YYYY')}</span>
              </ShowIf>
              <ShowIf condition={this.state.month != ''}>
                <span> tháng {this.state.month}</span>
              </ShowIf>
              <ShowIf condition={this.state.year != ''}>
                <span> năm {this.state.year}</span>
              </ShowIf>
            </p>
          </div>
        </div>
        <div className="bottom-content">
          <div className='wrap-block pl15 pr15 pt20'>
            <div className='row pl10 pr10 pb20 theo-doi'>
              <section className="wrap-block search-container col-80">
                <form className="search-form" action="javascript:void(0)" onSubmit={this.handleSearch.bind(this)}>
                  <input
                    type="text"
                    placeholder="Nhập tên người đứng đơn hoặc số CMND để tìm kiếm..."
                    className="search-input"
                    value={this.state.tuKhoa}
                    onChange={this.onChange.bind(this)}
                  />
                  <Button
                    type="submit"
                    text="Tìm kiếm"
                    className={this.state.tableLoading ? (this.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"}
                    />
                </form>
              </section>
              <div className='col-20 search-thanh-tra mt0'>
                <Link className='col-100 no-gutter btn-green tt-export' onClick={this.handleExportExcel.bind(this)}>Xuất đơn {this.state.tinhTrangXuLy == "DUNG_HAN"? "đúng hạn" : "trễ hạn"}
                </Link>
              </div>
            </div>
            <div className='row'>
              <span className="line-border"></span>
            </div>
          </div>
          <DataTable
            header={header.theoDoi.danhSachDonTreHan}
            dataList={this.state.data}
            pageData={this.state.pageData}
            parent={this}
            hideButtonExport
            search={this.state.search}
            tableLoading={this.state.tableLoading}
          >
            <RowItemDanhSachDon tenDonVi={this.state.tenDonVi}/>
          </DataTable>
        </div>
      </div>
    );
  }
}

DanhSachDon.defaultProps = {
  validators: {}
}

export default withRouter(DanhSachDon);



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/DanhSachDon.jsx